var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-removal-selector item-selector"},[_c('Modifier',{attrs:{"type":"removal","selector":_vm.removal},on:{"click":_vm.changeQuantity,"changed":function($event){return _vm.changeQuantity($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }